<template>
    <div>

    </div>
</template>
<script>

    import {mapActions} from 'vuex';

    export default {
        created: function () {
            this.getUserRole();
        },
        methods: {
            ...mapActions('n_user', ['getUserRole']),
        }
    }
</script>
